<template>
  <div :class="[
    fullWidth ? 'form-item-full' : 'form-item',
    {
      'form-item-compact': compact,
      'form-item-no-margin': noMargin
    }
  ]">
    <slot></slot>
  </div>
</template>

<script>
export default {
  name: 'FormItem',
  props: {
    fullWidth: {
      type: Boolean,
      default: false
    },
    compact: {
      type: Boolean,
      default: false
    },
    noMargin: {
      type: Boolean,
      default: false
    }
  }
}
</script>

<style scoped lang="scss">
.form-item {
  flex: 0 0 50%;
  padding: 0 12px;
  margin-bottom: 16px;
  transition: all 0.2s ease;
  
  @media (max-width: 768px) {
    flex: 0 0 100%;
  }
}

.form-item-full {
  flex: 0 0 100%;
  padding: 0 12px;
  margin-bottom: 16px;
  transition: all 0.2s ease;
}

.form-item-compact {
  margin-bottom: 8px;
}

.form-item-no-margin {
  margin-bottom: 0;
}

:deep(.ant-form-item-label) {
  font-weight: 500;
  
  label {
    color: #333;
    font-size: 14px;
  }
}

:deep(.ant-form-item) {
  margin-bottom: 16px;
  
  &:last-child {
    margin-bottom: 0;
  }
}

:deep(.ant-input),
:deep(.ant-input-number),
:deep(.ant-select),
:deep(.ant-picker) {
  border-radius: 4px;
  
  &:hover, &:focus {
    border-color: #FFCC32;
  }
}

:deep(.ant-input-number-focused),
:deep(.ant-select-focused .ant-select-selector),
:deep(.ant-picker-focused) {
  border-color: #FFCC32 !important;
  box-shadow: 0 0 0 2px rgba(255, 204, 50, 0.2) !important;
}
</style> 